import { render, staticRenderFns } from "./SystemChangeLog.vue?vue&type=template&id=5fd9d7a9&scoped=true&"
import script from "./SystemChangeLog.vue?vue&type=script&lang=js&"
export * from "./SystemChangeLog.vue?vue&type=script&lang=js&"
import style0 from "./SystemChangeLog.vue?vue&type=style&index=0&id=5fd9d7a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd9d7a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd9d7a9')) {
      api.createRecord('5fd9d7a9', component.options)
    } else {
      api.reload('5fd9d7a9', component.options)
    }
    module.hot.accept("./SystemChangeLog.vue?vue&type=template&id=5fd9d7a9&scoped=true&", function () {
      api.rerender('5fd9d7a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemChangeLog.vue"
export default component.exports